// libraries
import React from 'react'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface PositionBlockProps {
    href: string
    isExternal?: boolean
    title: string
    position: string
    details?: string
}


export default function PositionBlock({
    href,
    isExternal,
    title,
    position,
    details
}: PositionBlockProps) {
    return (
        <a
            href={href}
            target={isExternal ? '_blank' : undefined}
            className='position-block'
        >

            {isNonWhitespaceString(title) && (
                <p className='position-block__title'>
                    {title}
                </p>
            )}

            {isNonWhitespaceString(position) && (
                <p className='position-block__position'>
                    {position}
                </p>
            )}

            {isNonWhitespaceString(details) && (
                <div className='position-block__details'>
                    <p>Application due: </p> <div dangerouslySetInnerHTML={{ __html: details }} suppressHydrationWarning />
                </div>
            )}

            <span className='position-block__icon'>
                <svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path d='M4.24991 0.25H15.9999V12H13.9999V3.66421L2.24991 15.4142L0.835693 14L12.5857 2.25H4.24991V0.25Z' fill='currentColor'/></svg>
            </span>

        </a>
    )
}